export class AccessControlProvider {
    constructor(namespace, userId, entityId) {
        this.namespace = namespace;
        this.userId = userId;
        this.entityId = entityId;
        this.KEY_NAMESPACE_CONNECTOR = '@@';
    }
    getAccessControlledKey(key) {
        return [this.userId, this.entityId, this.namespace, key].join(this.KEY_NAMESPACE_CONNECTOR);
    }
}
//# sourceMappingURL=AccessControlProvider.js.map